
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index1XF_451GGibrNmgLj_45hA__45htG5PRO3S6qfoMQcXFvxnhMMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/index.vue?macro=true";
import { default as logincJ2WsymEAMeVjnbqS6BUgMyN0lWVyY5j4gDfsd1l_45QYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/login.vue?macro=true";
import { default as mgenFjjJTS6achCz7V_U7J_451SSnj_45Qw7m7A3EB_u6SdfVoQMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/quiz/mgen.vue?macro=true";
import { default as indexRN_45D_458GyrTvkC4PgwAx_9UQK6e770mOpuZLGtenibtEMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/index.vue?macro=true";
import { default as notesQabizweQl6YfwTViMgOT4e0ycq8R4W2ww8sqipSU2mcMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/notes.vue?macro=true";
import { default as indexnNxT_45mfp6nWMpbzOxbCsdqwV9Ht0kUPYHoYmCMxRKMwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentuH8TsyGZmtsdnLATPGnhNtT1axQsMt_452oVKeqJALMicMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45siteCGI_o_VYbh9u5W0LlDejs9wLzegNPnydLxa_45eN_mNLYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/plan-du-site.vue?macro=true";
import { default as editxWc32I5zHY6gEtA2fTptLBstAEzqeXRIP_45hf4kP35rwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/edit.vue?macro=true";
import { default as placesE9GNAOkmpQUknrrZJ9Br5ZHf_45pNBNY04f8tB8fbIMbEMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/places.vue?macro=true";
import { default as accessibilitenMZ1bcPVxQykJFfD7sVP_45J4M1sCn5Ju5l9K74ylmPyEMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/accessibilite.vue?macro=true";
import { default as _91id_93CKseWXtZsEk1tmNNpTYQy8exYicbdr4BODUU9woo718Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/messages/[id].vue?macro=true";
import { default as notifications_45Z7_45q15C9MeGT7osg1GmNN59as7C_458b8VfWtQZvk9fgMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/notifications.vue?macro=true";
import { default as indexOhz2BcMQxr15AvffVKTLfryEoew2_45B8fJwJlTUeOPuoMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/index.vue?macro=true";
import { default as indexvulx9tNWQXaPNcmVXUN6BdQiNTMFzdXzkjUevnE5C1wMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/index.vue?macro=true";
import { default as _91slug_93WC2gHZGqxo8Dnza7OHpO6v2V7HAkPshWGuvUH1nVJowMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/villes/[slug].vue?macro=true";
import { default as indexu_45YesV2_Ti808UG8Ubo3mNoCmLz5jwAaknG22HtIoE4Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/messages/index.vue?macro=true";
import { default as generique8wjfuYaFvKaBu_o1pfcsQ2rXA4cNRv36uu4pIY_wFJ4Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93V96BCosypLriF5yKFVQLLhlr8_Bi13oHrgmAOHpkw1AMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/reseaux/[slug].vue?macro=true";
import { default as missionsitgBfGWOMabwM_brh3hSePV0XE_So_45RqliD_yi1o8LoMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/missions.vue?macro=true";
import { default as indexopl6KhIUm5meyMXnMsKOuGrynzrG7gJ6bpfdeyoj3VYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/dashboard/index.vue?macro=true";
import { default as favoriswHspGOlJUoPVHDwYewvio2l4NY2s2BGGlRUIPxESV60Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93OibjgorwfK_456dAZDCE6cEnBVV5gVnpNY6vXSZAkWBRYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/activites/[slug].vue?macro=true";
import { default as logsSpeJ8AU2FsZNSN_459NvdZNtYoEk2NBEbyBmWTr8CGphEMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesTVTBSKkJU9evgizJKYdNsHYV4TPKjzwAM_450GU_T2afIMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legales7h0FEJhUf_45vhMXCRtnUbUCO9JvtufRXZjU_SLTMyeioMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/mentions-legales.vue?macro=true";
import { default as missionsx8KJUg9RFn1txGqDkjCKdou5e0S2lj0rWJqeoofVBi4Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/missions.vue?macro=true";
import { default as settingsQWQwAugXu0wbTyrBCQuEQSkk5hYpuA_45ad5qK0CNnp7AMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/settings.vue?macro=true";
import { default as temoignagesrrxuOea8vkDwVR1uQGZfvC6Iq1LOf0nzZxxwcIl4E1wMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/temoignages.vue?macro=true";
import { default as index3CxYpLe4DzMBbZhBoBMjn_NL1Y_45nAyE658sy6OkXR5QMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/index.vue?macro=true";
import { default as adminhNkZdg8_aifssCca3o6VZO6YMlPf_45qyLNMe_3f0cvXoMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/maintenance/admin.vue?macro=true";
import { default as indexnYCTsOC6eXMaqlOOEUAI59_45Zpz__uV9x0_45xYy378mHsMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/maintenance/index.vue?macro=true";
import { default as indexk09qRKB9cfRorYlwYVPQZLam3WeNzmfJRA6x1pcbOvYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/territoires/index.vue?macro=true";
import { default as _91hash_93HHzDtOch3ZiVVQKvl9m59PNyP6IpS_45AutD_qQmCvg7gMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/invitations/[hash].vue?macro=true";
import { default as utilisateurs8kFAEoVyJqpObjmhm8Xtc9bjBz9yx1KUirexTuvS0fAMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93fG3Us6_45a4eyY5Z87RKptsO2OoSh4LwDz9WUw61bQrngMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93I0sNfdZRQsgSjoD87fRH_m8Zo8x_45M0VhUS3ZiMJImMUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/departements/[slug].vue?macro=true";
import { default as indexizXJ__45kbQU2aoXrX5BBTJ_axhqfod2_45edOMr3280oBgMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/organisations/index.vue?macro=true";
import { default as preferencessfFti1FWYK1tHVsiIDpnBl57djV42KGAbSBR3MeCS0kMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/preferences.vue?macro=true";
import { default as organisationsnE9Q84seIkMXSzTBTwfa2tNCMc0bkuGLfnYumvCg2TYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/organisations.vue?macro=true";
import { default as _91token_93kNAsu7ZHFGyZMQfWohs_fHXQQPKrfSKMXLsCG_4dkqcMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/temoignages/[token].vue?macro=true";
import { default as postsqIgloQlh5TEi0lt__45RHBGwMsuQNWOAjTLH91t52OlHYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/posts.vue?macro=true";
import { default as indexKMigo2wkC6r0A3g_45fBI6SLOmNei9NQUcIM0nYZWLcoQMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/index.vue?macro=true";
import { default as addphHyWAQnG440CgaERSnH2e6_45jUqtQqpVzt8g3HXmBj4Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_938EC7YGRWiNQpn1Bzqkm3z3_oL8fh0N3EUvqooox9hekMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/organisations/[slug].vue?macro=true";
import { default as indexcOEeh3RR1kgBQJbrpJgfSCyMZWZzNlP_V2wbpDyHkWQMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/password-reset/index.vue?macro=true";
import { default as participationsAUs0aiM_QCYTL68ZaOnxYSHkJJH_45Cn2juiL3KUW6CMYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/participations.vue?macro=true";
import { default as emailsTsnhANrxvVkPuxePPFGrRMUZGRUdiFxVWCE2i7Y_n_454Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/emails.vue?macro=true";
import { default as indexkI7Xb5_Gfn_45R9F3568CnnbAszypWIM5ScTe_45xqb5kiYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/alertes/index.vue?macro=true";
import { default as notifications1mcoMI6gya8ZE8SJ9NwzxRbLm4S6pbBvVD2nsH72RRQMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/notifications.vue?macro=true";
import { default as index7XGJ8EARCCZNCSUA_45gwNVAqC7elp0Luf_PydYxP1A_EMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiquerg6NN6N_45Zh_45DZRYOtBzCOR0dheviXE1HGLREzVm4wRwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93CIsuyq_45J8WtINfzfMYj36MVMG0JNrlJ3p2Clpt_y_fUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/domaines-action/[slug].vue?macro=true";
import { default as indexlMgO_45b48Fiwia5ofhfxngUM0zGPB_45d523dTw8HleY_45EMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93nCIwEwiT7MdwxgkLQsQtmNDnvjGCTc64rGQIQa7FbE8Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensemblePbx05N7LHknTaLMP24Nep_45YnR5SdhBP_HXgtDuL3hHwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationsBlq7UfqEo2oYmT9TmbCL4DQiOuFNvtnGhCit5SOg17oMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/other/invitations.vue?macro=true";
import { default as messagesYXylXE1en_JYAnT4eTSboLV4KxA5Ab2QYKCjnV_45TqPQMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/messages.vue?macro=true";
import { default as placessYrsd6bLCCxjclrDQOB_450BVvAMMOvTWKjidCigNmOHUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/places.vue?macro=true";
import { default as addFpBCJK8F8vIoeYsIKwJAVitZqlCXBF9XLFqYf0bJTGQMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexOF_45v706gvpp07f_45ZVkPZuyI_45gvTtOdetg9qTtLZSo9MMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexvUWSTympisKDw1f4UJkop6Wkk_45vpVxC1eqaEt0PL2bIMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/missions-benevolat/index.vue?macro=true";
import { default as dates1IIKTCsPHZ3ApLbcj4a0eHZLPSZ_45hLXes4J_45g3Vl_PkMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexZT4HNOH8Jj6Ma60082F47IFakzaAxx1tdk67Ob2v1DkMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxJbX9esrCHuSd8bnoVpKtFCpuOIvGm0fRdLwUoqWfVyEMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as title2uYI9uT6w970MtjD3_XIx5RF5iR6WQ1e6dQK_6RAmUYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/title.vue?macro=true";
import { default as index1mfS0sJoYz0VuY6keEqBQ_45C_459mdWFmQ_45zn0oMAJZIq8Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/organisations/index.vue?macro=true";
import { default as missionsddGJ8OBnRXNvVLzQ_99aiJZLSQjba5XgYcNOX5Wx_P0Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/missions.vue?macro=true";
import { default as addmqY_45eHN5xIY8C4yerBI6bdxHca9uvBxq5MOaS_XdpEMMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuelrpVyR8_SALslGlc3D_459VCy95tnbljpF4yj_45q2D1ljuwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as index6xpvLHxRA_45hTLwYzDac3sb9CJNDwEiEg9I8y0lPE4NgMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/participations/index.vue?macro=true";
import { default as indexGhK_xIA6UXLOWYS6zeUMIejSB7nLBtWaCV2gOo2NrEEMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexLJQZq3umT_GaVQx8hhjWz_KschGypzGKNFCG0aKbX7cMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/benevole/index.vue?macro=true";
import { default as addMkH2M4BkOBTeJO7OLGaLBxoErnmZhHHwna4oBCOIVOMMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as addregqdGSstwp0PKzW868XhXSgrOBtCFW2XICjK6Y2vNMMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addKmXJjJXVoa3jnA_458NeXN5KX0MiR__45HokdCmnlR57964Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexe_45mycft_4555IdGtfMXC1928hPqhdGkYliCmOfmWLfzfYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsTs_45UHbop8GLg9UAO93Ti4zurAIQOomSJggwFW59YBMEMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/conversions.vue?macro=true";
import { default as edit8rWZAcAiX3Yyt_45dwQ1Y6tzlb_45gT834Agm3y5mjSy4gwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteV6dNAZ5X84bgHQthtCq0GAtFHSFMWoVEH4YAAqFjQH4Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/politique-de-confidentialite.vue?macro=true";
import { default as indextOson_cqd0VHpIIh_v9_o7D1RRIm0qFFeh_zlz7UtBUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as add9rKuB3lQ04UJbGdMMMp_KO_tZ_rffJauP3i0KLIOx0oMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevoleshMDmlYIgjzUGBwShEZ3ihri1LTYIt1Km_wN4WOTs7YEMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editfv5aS6xGHoPnrHAYdXyH1tWL8KkXXbm254Gvxj_45cqBMMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursM38H6pj6ZZJIWfyO0PR3rnuBPW5c4_45A2MQGT5ivhAs0Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexItPt9Z3fGDwQADd6OLGORZ4LF2AItxTAFQjWm9x00AIMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexfJsE_OJGm46W7pW7EcaM9BIkghTdPaPrOxh2Eyr_Vb8Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexBnVKo2exQjED5_voVwetutCgLxXAqUnxe69TjyzBiJ8Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/index.vue?macro=true";
import { default as indexX_45TIPv9_45CRYP_Ycmj3qSqLe1gVkzdEH33pITAWx90OkMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendreO5G0DYaKLpKYN_3V6refXWPU0jPBWJf89Uy5AhBFbQUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexoboqFWFx9z2Glo89EKcpNVoHE0XiUOXNvp6cINBCS5oMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addGGgblVpdlRYC45KrVjTZUR3Z_8DDoqq_45Bszg5t5_5KsMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as index1kMLfyk_45PcV_7N3zUzqlaaxFlyq4wFot9nlt7dhXllMMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as edit9HX3haQNkhnO0Q2J7gE3_ciFQIsv1IjWEbgDPaAFfUAMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93MAeNF31f9EB5PnEF2SFMvXIOB_45RPhbXWe_hM9TWMvXcMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planeteM4DtnYTLfGzNQXAVhtEoJK_45TnpSD1mrw16TiWPjSjt0Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexQ5zEprLqrD4Cq_4570Ayp_7SXVXlFdhuXPNu_80yz4hkIMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsz6IrrXSccG60QGB8qmMszqypNmlrBTuSRDkzbviohuYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/participations.vue?macro=true";
import { default as indexRCpISf4mUkJdftQ5xXSf7__9UijbmTq41h6Vm5qL4asMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logs5nX7yprTHAGoVS9G_45ECHGU8vrAasn0_C3j79MRFYFrQMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/referents/activity-logs.vue?macro=true";
import { default as edittNSHweV8xpNhGtDSAzjeswAgqRZ40g7XYSWSv52jlFYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexrqs9MpMBzKXLcckQpnIrOBa47WBkPNghO4McXedh5HAMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsUjIZ4gbXB5fUFPcv_45jYZW3uPAx7tp9yjINZdCV43o_45UMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesFdY3USmJbX_45VaM3i_guHwcsz_EyUEu2quLc2W5qW62wMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as edit6xQFGz0hmAlBeRb7u_45smI61gYC5TCbto_WveToGyUhUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexE3ILTdODwH_45CEAHOHKqIf6aSuUFbXgedZmg3vVP8OFoMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexn7P11_45rypnsVY42Tb37wNgWPdRmSLgcpl5_nckytm_45UMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesQTOYyopfuIy97mWI_45RY0H84rvpi6SohEWFSt0H4jbDwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editg0dGTDND6erW6C2Ww13dWP5Gnpmgy75KdmTljXZ5KtcMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profileDodDwrN5zeoltMB3KFDBO8eyz_3ICKZmSTtehrkQM88Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementN3r87OmLSRsocS28UX35evg5HpazyVrVzp1H0MdkphIMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsG1YetK5OrYS8Io_DllUpcMunhMxK_lUy0SOUf_puFUkMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editLNagzPzNSjker1eLpenAnpSkSu_45E5Jkd5YeRoSPsN4EMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addMPeqN_45ujEDjdNWxoLEr8EC6BjFNFTkMXtbgkzg8bbDwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationaZrjiFmOCs5qRNnTA5mNEDrgfgSOIPHtV1M7zsakrDoMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexxBMNkCLqmWDRm7kW_xfaiyhbE4sSio7vYnHHXgg0EekMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as editkg18hODuydBvxOooNsmOMkOjuNrgy6pIT1oRDh72zVUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionsKEldQHF9oZdPpnhem5K1pzLjfTCvV73oRz3ZFGtluL8Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationsBvxHhfmNhlWhe48dI73OAUsXoFJ6KQckhW_t9G5wYLQMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevoles8oi_ruSmdG6R3eb_45zpd3XbXb9hNWYV1vWXzG1glDFe4Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexingYJsGXzdWGJdefDHXOx00pmmqbpAoy58zOJLIY3zS8EcMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as index293cevFrVYmnaYqjv767SeiqAwO9bUY2V6mEw4CFlz4Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editIur0GNyW9UxytMZ1SFWO31shsgYpYYDcIKzVtkguYj4Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as index_4XvxUvFlbe18ysZD4QewwBTrKDBbjVmjwkjKGZqU7gMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profile6ovlWNFQ0pDcfPj5o_457WUOGyJVAgkYzhJDWNIoTC_45V8Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as index2q3oEfVTHzWs0UWHKmvo6GPJf3jG9TW2d2nc3fzWNBEMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editnwilpvK31WAwALPxSHNtb9zDEN0a1O_n4EqIB3XPfgAMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addeDwtstFiertIrPveUjlzTjoccOWgx67MI0ZTRFWbC5QMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesRqq_vtchv4J2pUP7mUK6kV0a8Kz3udJnpFuqvJSSoC8Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferencesXSM_45aoRA5LdnmidQ0utiKfjwANrWStTFTJIVnXkiDgYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45usersn03RrXzkuHFHnYohudkBJMwwL07TwVUtLhgyledra58Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresVgLiscSyvuKsD27IbkwGjOf3ylYNlbAXAN7EduMBHjAMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsablesxSh2mZZtA9oC1J_451j7sr0XS5xxv9uosdZlyHQya8WGMMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationzqRAYzRjvt8Syk5MRPxp19VYZdLGmkXzOJGn04NeOxUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedMgg7tgLQ1ypCBMYe4agnRYk_isUqPyYcfcaQsy7Tt8wMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsRMG_RWue9Qd0yyezQri8nJsDQWA3AulXjFXXRZfNxeAMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45rolek7RrRDSEkFdzgl3GkL767T5RPkTccmwOJ6_nSX_45I1V4Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsw7EL_45hmST1z0I0T4hAxDEMUTmVaF4frMeRZ7PfH6vMYMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as editF6NZcEUrPVsrLAJs_aquoyeVqgPFlL7pSSEj9YBxYZIMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilitesrSd9ieEkat_45X90EYxnxXUA7nw_45KrJVZizqYB_0FEORQMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkJTfJoRWSk3DCDgeYYoDJ6EnnlykJFj3buZLkI1mu8QwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as indexI4KboyFMQBsmAoOkDaEf5mGUEa3EiF6ZQCMg6csqofMMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectiviteuRvyHrsuC0uPlkUToPzjGkFQYOhE9NZbLHJ2nZb6T8QMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationHOyQEHGoO5PDVqf1Ig2kmIKs5thoTGvkHco778S24msMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informations3WdutwXYJFtXQS9xaRPtPrWExWpPvEsynGRWFR9knWcMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantSO9yon6CoeUU5W9EtbFWVnWmLSkYqzZRvQ1iVzkr9KUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantOHvdrwmEMMwJ9hWaf3r_45UzxDtivfasBBA0B1yeTj_DUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as index2I9Ulhqanxn1bvFlwixwD7F_450VUODH3_iluJgjNf2A0Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesYCsr4kfKOSQsTKxLtC1svuNGnZlmSHUTsEIop6XVUmgMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45validerw5q1sJWNhwwk0MztaXRSgYPlalSZYU0sRnqYAVGDgwsMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesoG41HwvFOPUER9pe2hGjeDC8bFYdWM9eS5BpvRlxU8MMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagesqTnmdDy4vvWlwcMggX72YpMxWEPPO0ajL_UvNf0GQiwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsGI5u4LfQPDdSDkiLscuNmwxYVA1Tmu8iOL_45Wmctm1f4Meta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedO55eMy5sGqFemHPaHFdL5YTRtYEr6e_mKx78HA_45YDgsMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectd2cnIyKLHfZUCAjjXGkiSHT61dBB_L5IspBjToOkqOgMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45validerRImwKEo3F74Rx7qu5fkd9dFQWyVWkaUz8jVngHdU65IMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementqR9YA5Ws_hTbog0byN5E69dTj_45pRpVHQTPK_45MbKMCNoMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationnMwOTEZ2GrR3CD5aXoh3mmbxbmuTmONcnNmHTTQmnrUMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationfiRtS7fXP44_ZNw5iZEZc2FwTm7N0WpwolLrDOChS_EMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45validerIq4J2SI_lUFbWBcuQmiTJ7S1GpQZXs5thvXJCrifBOoMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annulees9tP8st_PNAnf2nO6HDELTTkGEvOg4I9gQUxneUwRrtwMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI } from "/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logincJ2WsymEAMeVjnbqS6BUgMyN0lWVyY5j4gDfsd1l_45QYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenFjjJTS6achCz7V_U7J_451SSnj_45Qw7m7A3EB_u6SdfVoQMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexRN_45D_458GyrTvkC4PgwAx_9UQK6e770mOpuZLGtenibtEMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesQabizweQl6YfwTViMgOT4e0ycq8R4W2ww8sqipSU2mcMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexnNxT_45mfp6nWMpbzOxbCsdqwV9Ht0kUPYHoYmCMxRKMwMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editxWc32I5zHY6gEtA2fTptLBstAEzqeXRIP_45hf4kP35rwMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesE9GNAOkmpQUknrrZJ9Br5ZHf_45pNBNY04f8tB8fbIMbEMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93CKseWXtZsEk1tmNNpTYQy8exYicbdr4BODUU9woo718Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notifications_45Z7_45q15C9MeGT7osg1GmNN59as7C_458b8VfWtQZvk9fgMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexOhz2BcMQxr15AvffVKTLfryEoew2_45B8fJwJlTUeOPuoMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexvulx9tNWQXaPNcmVXUN6BdQiNTMFzdXzkjUevnE5C1wMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexu_45YesV2_Ti808UG8Ubo3mNoCmLz5jwAaknG22HtIoE4Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generique8wjfuYaFvKaBu_o1pfcsQ2rXA4cNRv36uu4pIY_wFJ4Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93V96BCosypLriF5yKFVQLLhlr8_Bi13oHrgmAOHpkw1AMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsitgBfGWOMabwM_brh3hSePV0XE_So_45RqliD_yi1o8LoMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexopl6KhIUm5meyMXnMsKOuGrynzrG7gJ6bpfdeyoj3VYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favoriswHspGOlJUoPVHDwYewvio2l4NY2s2BGGlRUIPxESV60Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsSpeJ8AU2FsZNSN_459NvdZNtYoEk2NBEbyBmWTr8CGphEMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionsx8KJUg9RFn1txGqDkjCKdou5e0S2lj0rWJqeoofVBi4Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingsQWQwAugXu0wbTyrBCQuEQSkk5hYpuA_45ad5qK0CNnp7AMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/settings.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: index3CxYpLe4DzMBbZhBoBMjn_NL1Y_45nAyE658sy6OkXR5QMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminhNkZdg8_aifssCca3o6VZO6YMlPf_45qyLNMe_3f0cvXoMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexnYCTsOC6eXMaqlOOEUAI59_45Zpz__uV9x0_45xYy378mHsMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93HHzDtOch3ZiVVQKvl9m59PNyP6IpS_45AutD_qQmCvg7gMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateurs8kFAEoVyJqpObjmhm8Xtc9bjBz9yx1KUirexTuvS0fAMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencessfFti1FWYK1tHVsiIDpnBl57djV42KGAbSBR3MeCS0kMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsnE9Q84seIkMXSzTBTwfa2tNCMc0bkuGLfnYumvCg2TYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93kNAsu7ZHFGyZMQfWohs_fHXQQPKrfSKMXLsCG_4dkqcMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsqIgloQlh5TEi0lt__45RHBGwMsuQNWOAjTLH91t52OlHYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: indexKMigo2wkC6r0A3g_45fBI6SLOmNei9NQUcIM0nYZWLcoQMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addphHyWAQnG440CgaERSnH2e6_45jUqtQqpVzt8g3HXmBj4Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_938EC7YGRWiNQpn1Bzqkm3z3_oL8fh0N3EUvqooox9hekMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexcOEeh3RR1kgBQJbrpJgfSCyMZWZzNlP_V2wbpDyHkWQMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationsAUs0aiM_QCYTL68ZaOnxYSHkJJH_45Cn2juiL3KUW6CMYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsTsnhANrxvVkPuxePPFGrRMUZGRUdiFxVWCE2i7Y_n_454Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexkI7Xb5_Gfn_45R9F3568CnnbAszypWIM5ScTe_45xqb5kiYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notifications1mcoMI6gya8ZE8SJ9NwzxRbLm4S6pbBvVD2nsH72RRQMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: index7XGJ8EARCCZNCSUA_45gwNVAqC7elp0Luf_PydYxP1A_EMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexlMgO_45b48Fiwia5ofhfxngUM0zGPB_45d523dTw8HleY_45EMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93nCIwEwiT7MdwxgkLQsQtmNDnvjGCTc64rGQIQa7FbE8Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensemblePbx05N7LHknTaLMP24Nep_45YnR5SdhBP_HXgtDuL3hHwMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationsBlq7UfqEo2oYmT9TmbCL4DQiOuFNvtnGhCit5SOg17oMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesYXylXE1en_JYAnT4eTSboLV4KxA5Ab2QYKCjnV_45TqPQMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placessYrsd6bLCCxjclrDQOB_450BVvAMMOvTWKjidCigNmOHUMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addFpBCJK8F8vIoeYsIKwJAVitZqlCXBF9XLFqYf0bJTGQMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexOF_45v706gvpp07f_45ZVkPZuyI_45gvTtOdetg9qTtLZSo9MMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexvUWSTympisKDw1f4UJkop6Wkk_45vpVxC1eqaEt0PL2bIMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: dates1IIKTCsPHZ3ApLbcj4a0eHZLPSZ_45hLXes4J_45g3Vl_PkMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexZT4HNOH8Jj6Ma60082F47IFakzaAxx1tdk67Ob2v1DkMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxJbX9esrCHuSd8bnoVpKtFCpuOIvGm0fRdLwUoqWfVyEMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: title2uYI9uT6w970MtjD3_XIx5RF5iR6WQ1e6dQK_6RAmUYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: index1mfS0sJoYz0VuY6keEqBQ_45C_459mdWFmQ_45zn0oMAJZIq8Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionsddGJ8OBnRXNvVLzQ_99aiJZLSQjba5XgYcNOX5Wx_P0Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addmqY_45eHN5xIY8C4yerBI6bdxHca9uvBxq5MOaS_XdpEMMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelrpVyR8_SALslGlc3D_459VCy95tnbljpF4yj_45q2D1ljuwMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: index6xpvLHxRA_45hTLwYzDac3sb9CJNDwEiEg9I8y0lPE4NgMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexGhK_xIA6UXLOWYS6zeUMIejSB7nLBtWaCV2gOo2NrEEMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexLJQZq3umT_GaVQx8hhjWz_KschGypzGKNFCG0aKbX7cMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addMkH2M4BkOBTeJO7OLGaLBxoErnmZhHHwna4oBCOIVOMMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: addregqdGSstwp0PKzW868XhXSgrOBtCFW2XICjK6Y2vNMMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addKmXJjJXVoa3jnA_458NeXN5KX0MiR__45HokdCmnlR57964Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexe_45mycft_4555IdGtfMXC1928hPqhdGkYliCmOfmWLfzfYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsTs_45UHbop8GLg9UAO93Ti4zurAIQOomSJggwFW59YBMEMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: edit8rWZAcAiX3Yyt_45dwQ1Y6tzlb_45gT834Agm3y5mjSy4gwMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indextOson_cqd0VHpIIh_v9_o7D1RRIm0qFFeh_zlz7UtBUMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: add9rKuB3lQ04UJbGdMMMp_KO_tZ_rffJauP3i0KLIOx0oMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevoleshMDmlYIgjzUGBwShEZ3ihri1LTYIt1Km_wN4WOTs7YEMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editfv5aS6xGHoPnrHAYdXyH1tWL8KkXXbm254Gvxj_45cqBMMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursM38H6pj6ZZJIWfyO0PR3rnuBPW5c4_45A2MQGT5ivhAs0Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexItPt9Z3fGDwQADd6OLGORZ4LF2AItxTAFQjWm9x00AIMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexfJsE_OJGm46W7pW7EcaM9BIkghTdPaPrOxh2Eyr_Vb8Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendreO5G0DYaKLpKYN_3V6refXWPU0jPBWJf89Uy5AhBFbQUMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexoboqFWFx9z2Glo89EKcpNVoHE0XiUOXNvp6cINBCS5oMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addGGgblVpdlRYC45KrVjTZUR3Z_8DDoqq_45Bszg5t5_5KsMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: index1kMLfyk_45PcV_7N3zUzqlaaxFlyq4wFot9nlt7dhXllMMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: edit9HX3haQNkhnO0Q2J7gE3_ciFQIsv1IjWEbgDPaAFfUAMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planeteM4DtnYTLfGzNQXAVhtEoJK_45TnpSD1mrw16TiWPjSjt0Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexQ5zEprLqrD4Cq_4570Ayp_7SXVXlFdhuXPNu_80yz4hkIMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsz6IrrXSccG60QGB8qmMszqypNmlrBTuSRDkzbviohuYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logs5nX7yprTHAGoVS9G_45ECHGU8vrAasn0_C3j79MRFYFrQMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: edittNSHweV8xpNhGtDSAzjeswAgqRZ40g7XYSWSv52jlFYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexrqs9MpMBzKXLcckQpnIrOBa47WBkPNghO4McXedh5HAMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsUjIZ4gbXB5fUFPcv_45jYZW3uPAx7tp9yjINZdCV43o_45UMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesFdY3USmJbX_45VaM3i_guHwcsz_EyUEu2quLc2W5qW62wMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: edit6xQFGz0hmAlBeRb7u_45smI61gYC5TCbto_WveToGyUhUMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexE3ILTdODwH_45CEAHOHKqIf6aSuUFbXgedZmg3vVP8OFoMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexn7P11_45rypnsVY42Tb37wNgWPdRmSLgcpl5_nckytm_45UMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesQTOYyopfuIy97mWI_45RY0H84rvpi6SohEWFSt0H4jbDwMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editg0dGTDND6erW6C2Ww13dWP5Gnpmgy75KdmTljXZ5KtcMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profileDodDwrN5zeoltMB3KFDBO8eyz_3ICKZmSTtehrkQM88Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsG1YetK5OrYS8Io_DllUpcMunhMxK_lUy0SOUf_puFUkMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editLNagzPzNSjker1eLpenAnpSkSu_45E5Jkd5YeRoSPsN4EMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addMPeqN_45ujEDjdNWxoLEr8EC6BjFNFTkMXtbgkzg8bbDwMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexxBMNkCLqmWDRm7kW_xfaiyhbE4sSio7vYnHHXgg0EekMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editkg18hODuydBvxOooNsmOMkOjuNrgy6pIT1oRDh72zVUMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsKEldQHF9oZdPpnhem5K1pzLjfTCvV73oRz3ZFGtluL8Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsBvxHhfmNhlWhe48dI73OAUsXoFJ6KQckhW_t9G5wYLQMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingYJsGXzdWGJdefDHXOx00pmmqbpAoy58zOJLIY3zS8EcMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: index293cevFrVYmnaYqjv767SeiqAwO9bUY2V6mEw4CFlz4Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editIur0GNyW9UxytMZ1SFWO31shsgYpYYDcIKzVtkguYj4Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: index_4XvxUvFlbe18ysZD4QewwBTrKDBbjVmjwkjKGZqU7gMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profile6ovlWNFQ0pDcfPj5o_457WUOGyJVAgkYzhJDWNIoTC_45V8Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: index2q3oEfVTHzWs0UWHKmvo6GPJf3jG9TW2d2nc3fzWNBEMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editnwilpvK31WAwALPxSHNtb9zDEN0a1O_n4EqIB3XPfgAMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addeDwtstFiertIrPveUjlzTjoccOWgx67MI0ZTRFWbC5QMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesRqq_vtchv4J2pUP7mUK6kV0a8Kz3udJnpFuqvJSSoC8Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesXSM_45aoRA5LdnmidQ0utiKfjwANrWStTFTJIVnXkiDgYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45usersn03RrXzkuHFHnYohudkBJMwwL07TwVUtLhgyledra58Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresVgLiscSyvuKsD27IbkwGjOf3ylYNlbAXAN7EduMBHjAMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationzqRAYzRjvt8Syk5MRPxp19VYZdLGmkXzOJGn04NeOxUMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedMgg7tgLQ1ypCBMYe4agnRYk_isUqPyYcfcaQsy7Tt8wMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsRMG_RWue9Qd0yyezQri8nJsDQWA3AulXjFXXRZfNxeAMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45rolek7RrRDSEkFdzgl3GkL767T5RPkTccmwOJ6_nSX_45I1V4Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsw7EL_45hmST1z0I0T4hAxDEMUTmVaF4frMeRZ7PfH6vMYMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: editF6NZcEUrPVsrLAJs_aquoyeVqgPFlL7pSSEj9YBxYZIMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesrSd9ieEkat_45X90EYxnxXUA7nw_45KrJVZizqYB_0FEORQMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkJTfJoRWSk3DCDgeYYoDJ6EnnlykJFj3buZLkI1mu8QwMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: indexI4KboyFMQBsmAoOkDaEf5mGUEa3EiF6ZQCMg6csqofMMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectiviteuRvyHrsuC0uPlkUToPzjGkFQYOhE9NZbLHJ2nZb6T8QMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationHOyQEHGoO5PDVqf1Ig2kmIKs5thoTGvkHco778S24msMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informations3WdutwXYJFtXQS9xaRPtPrWExWpPvEsynGRWFR9knWcMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantSO9yon6CoeUU5W9EtbFWVnWmLSkYqzZRvQ1iVzkr9KUMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantOHvdrwmEMMwJ9hWaf3r_45UzxDtivfasBBA0B1yeTj_DUMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: index2I9Ulhqanxn1bvFlwixwD7F_450VUODH3_iluJgjNf2A0Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesYCsr4kfKOSQsTKxLtC1svuNGnZlmSHUTsEIop6XVUmgMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45validerw5q1sJWNhwwk0MztaXRSgYPlalSZYU0sRnqYAVGDgwsMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesoG41HwvFOPUER9pe2hGjeDC8bFYdWM9eS5BpvRlxU8MMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagesqTnmdDy4vvWlwcMggX72YpMxWEPPO0ajL_UvNf0GQiwMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsGI5u4LfQPDdSDkiLscuNmwxYVA1Tmu8iOL_45Wmctm1f4Meta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedO55eMy5sGqFemHPaHFdL5YTRtYEr6e_mKx78HA_45YDgsMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45validerRImwKEo3F74Rx7qu5fkd9dFQWyVWkaUz8jVngHdU65IMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationnMwOTEZ2GrR3CD5aXoh3mmbxbmuTmONcnNmHTTQmnrUMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationfiRtS7fXP44_ZNw5iZEZc2FwTm7N0WpwolLrDOChS_EMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45validerIq4J2SI_lUFbWBcuQmiTJ7S1GpQZXs5thvXJCrifBOoMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annulees9tP8st_PNAnf2nO6HDELTTkGEvOg4I9gQUxneUwRrtwMeta || {},
    component: () => import("/build/9ad6a088-d4f9-4bb0-b1be-46c460434f4e/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/user/settings",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/inscription/organisation",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/statistiques",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  },
  {
    name: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWIMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub49se0dcfvT7zJ_45PHfKPcM2cP5s0aubUotsIHWEnsbWI
  }
]